'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _SagaReducerFactory2 = require('./SagaReducerFactory');

var _SagaReducerFactory3 = _interopRequireDefault(_SagaReducerFactory2);

var _effects = require('redux-saga/effects');

var _I18nActions = require('../actions/I18nActions');

var I18nActions = _interopRequireWildcard(_I18nActions);

var _wixLocales = require('@wix/wix-locales');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchHelper);

var I18N_DEFAULT_URL = '/i18n';

var INITIAL_STATE = {
    locale: null,
    secondChoiceLocale: null,
    uxMode: false,
    uxLanguage: null,
    secondarySwitched: false,
    requestedLocale: null,
    localeData: {}
};

var _SagaReducerFactory = (0, _SagaReducerFactory3.default)({
    actionTypes: I18nActions.types,
    actionCreators: I18nActions.actions,
    initState: INITIAL_STATE
}),
    handle = _SagaReducerFactory.handle,
    saga = _SagaReducerFactory.saga,
    reducer = _SagaReducerFactory.reducer,
    updateState = _SagaReducerFactory.updateState;

function fetchHelper(fetch, url) {
    var response;
    return _regenerator2.default.wrap(function fetchHelper$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(fetch, url);

                case 2:
                    response = _context.sent;
                    _context.next = 5;
                    return (0, _effects.call)([response, response.json]);

                case 5:
                    return _context.abrupt('return', _context.sent);

                case 6:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

handle(I18nActions.types.I18N_INIT, /*#__PURE__*/_regenerator2.default.mark(function _callee(sagaParams, action) {
    var _action$payload, uxMode, localeData, secondarySwitched, secondChoiceLocale, uxLanguage;

    return _regenerator2.default.wrap(function _callee$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _action$payload = action.payload, uxMode = _action$payload.uxMode, localeData = _action$payload.localeData, secondarySwitched = _action$payload.secondarySwitched, secondChoiceLocale = _action$payload.secondChoiceLocale, uxLanguage = _action$payload.uxLanguage;
                    _context2.next = 3;
                    return (0, _effects.put)(updateState({
                        uxMode: uxMode,
                        localeData: localeData,
                        secondarySwitched: secondarySwitched,
                        secondChoiceLocale: secondChoiceLocale,
                        uxLanguage: uxLanguage,
                        locale: localeData ? localeData.locale : null
                    }));

                case 3:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _callee, this);
}));

handle(I18nActions.types.I18N_REQUEST_CHANGE, /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref, action) {
    var fetch = _ref.fetch,
        i18nUrl = _ref.i18nUrl;

    var _action$payload2, organizationLocale, countryCode, uxLanguage, secondarySwitched, uxMode, currentLocale, newLocale, secondChoiceLocale, temp, requestedLocale, response, localeData;

    return _regenerator2.default.wrap(function _callee2$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _action$payload2 = action.payload, organizationLocale = _action$payload2.organizationLocale, countryCode = _action$payload2.countryCode;
                    _context3.next = 3;
                    return (0, _effects.select)(function (state) {
                        return state.i18nData.uxLanguage;
                    });

                case 3:
                    uxLanguage = _context3.sent;
                    _context3.next = 6;
                    return (0, _effects.select)(function (state) {
                        return state.i18nData.secondarySwitched;
                    });

                case 6:
                    secondarySwitched = _context3.sent;
                    _context3.next = 9;
                    return (0, _effects.select)(function (state) {
                        return state.i18nData.uxMode;
                    });

                case 9:
                    uxMode = _context3.sent;
                    _context3.next = 12;
                    return (0, _effects.select)(function (state) {
                        return state.i18nData.locale;
                    });

                case 12:
                    currentLocale = _context3.sent;
                    newLocale = _wixLocales.WixLocales.bestLocaleFor({
                        wixUserLanguage: uxLanguage,
                        countryCode: countryCode
                    });

                    // Second choice locale, when in UX mode, is the locale suggested by
                    // Wix without being changed as a selection of the country

                    secondChoiceLocale = _wixLocales.WixLocales.bestWixLocaleFor({
                        wixUserLanguage: uxLanguage,
                        countryCode: countryCode
                    });

                    // If both the locale and the second choice locale are for the same
                    // language, don't really show a choice

                    if (secondChoiceLocale.substr(0, 2) === newLocale.substr(0, 2)) {
                        secondChoiceLocale = null;
                    }

                    if (secondarySwitched && secondChoiceLocale) {
                        temp = newLocale;

                        newLocale = secondChoiceLocale;
                        secondChoiceLocale = temp;
                    }

                    requestedLocale = void 0;


                    if (uxMode) {
                        if (newLocale !== currentLocale) {
                            requestedLocale = newLocale;
                        }
                    } else {
                        if (organizationLocale !== currentLocale) {
                            requestedLocale = organizationLocale;
                            secondChoiceLocale = null;
                        }
                    }

                    if (requestedLocale) {
                        _context3.next = 21;
                        break;
                    }

                    return _context3.abrupt('return');

                case 21:
                    _context3.next = 23;
                    return fetchHelper(fetch, (i18nUrl || I18N_DEFAULT_URL) + '/' + requestedLocale);

                case 23:
                    response = _context3.sent;
                    localeData = response.value;
                    _context3.next = 27;
                    return (0, _effects.put)(updateState({
                        locale: localeData.locale,
                        localeData: localeData,
                        secondChoiceLocale: secondChoiceLocale
                    }));

                case 27:
                    _context3.next = 29;
                    return (0, _effects.put)(I18nActions.actions.i18nViewReadyForChange({ localeData: localeData }));

                case 29:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _callee2, this);
}));

handle(I18nActions.types.I18N_SWITCH_TO_SECONDARY, /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref2) {
    var fetch = _ref2.fetch,
        i18nUrl = _ref2.i18nUrl;
    var locale, secondarySwitched, secondChoiceLocale, response, localeData;
    return _regenerator2.default.wrap(function _callee3$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.select)(function (state) {
                        return state.i18nData.locale;
                    });

                case 2:
                    locale = _context4.sent;
                    _context4.next = 5;
                    return (0, _effects.select)(function (state) {
                        return state.i18nData.secondarySwitched;
                    });

                case 5:
                    secondarySwitched = _context4.sent;
                    _context4.next = 8;
                    return (0, _effects.select)(function (state) {
                        return state.i18nData.secondChoiceLocale;
                    });

                case 8:
                    secondChoiceLocale = _context4.sent;

                    if (secondChoiceLocale) {
                        _context4.next = 11;
                        break;
                    }

                    return _context4.abrupt('return');

                case 11:
                    _context4.next = 13;
                    return fetchHelper(fetch, (i18nUrl || I18N_DEFAULT_URL) + '/' + secondChoiceLocale);

                case 13:
                    response = _context4.sent;
                    localeData = response.value;
                    _context4.next = 17;
                    return (0, _effects.put)(updateState({
                        locale: localeData.locale,
                        localeData: localeData,
                        secondarySwitched: !secondarySwitched,
                        secondChoiceLocale: locale
                    }));

                case 17:
                    _context4.next = 19;
                    return (0, _effects.put)(I18nActions.actions.i18nViewReadyForChange({ localeData: localeData }));

                case 19:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _callee3, this);
}));

exports.default = { saga: saga, reducer: reducer };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/sagas/I18nSaga.js
// module id = 1407
// module chunks = 0